import React from "react";
import { ScreenNameList } from "@lib/utilities/Constants";
import { findUsMapURL, getPolicyNumber } from "@lib/utilities/Helpers";
import { useAppDispatch, useAppSelector } from "@lib";
import { useFocusEffect } from "@react-navigation/native";
import Crashlytics from "@lib/utilities/crashlyticsUtils/CrashlyticsUtils";
import { CONTACT_AGENT_ROUTE } from "../../../src/navigation/NavigationConstants";
import { messages } from "../../../src/resources/strings";
import { setError } from "@lib";
import { formattedMailingAddress } from "@lib/utilities/Formatters";
import { setCurrentPolicyNumber } from "@lib";

export const useContactAgent = () => {
  //redux
  const policyData = useAppSelector((state) => state.policyReducer);
  const dispatch = useAppDispatch();

  const { agent, loading, error, policyNumber } = useAppSelector(
    (state) => state.policyDetailReducer
  );

  useFocusEffect(
    React.useCallback(() => {
      Crashlytics.logScreen(CONTACT_AGENT_ROUTE);
    }, [policyData])
  );

  const errorData = {
    message: error,
    screenName: ScreenNameList.contactAgent,
  };

  const onReloadPress = async () => {
    const policyNumber = await getPolicyNumber();
    const policy = policyData.policies.find(
      (item: any) => item.policyNumber === policyNumber
    );
    if (policy) {
      dispatch(setCurrentPolicyNumber(policy.policyNumber));
      dispatch(setError(messages.error.noError));
    }
  };

  return {
    // data states
    policyNumber,
    policyList: policyData.policies,
    agent,

    // loading states
    loading,
    error,
    errorData,

    // functions
    findUsMapURL: () => {
      findUsMapURL(formattedMailingAddress(agent?.mailingAddress));
    },
    onReloadPress,
    onEndTimer: () => {
      dispatch(setError(messages.error.noError));
    },
  };
};
